export const COOKIE_NAME = 'fontSizeRate';
export const STEP_SIZE = 10;
export const MAX_RATE = 120;
export const MIN_RATE = 80;
export const DEFAULT_RATE = 100;
export const DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
};
export const TARGETS = [
  'article h1',
  'article .altHeadline',
  'article .subtitle',
  'article .alternativeHeadline',
  '.vikont p',
  '.vikont li',
  '.vikont h2',
  '.vikont h3',
  '.vikont h4',
  '.vikont h5',
  '.vikont h6',
  '.lead',
  '.table-of-contents h2',
  '.table-of-contents ul',
];
